import { Quote } from 'components/Quote'
import { ReactNode } from 'react'
const url = window.location.href
const mandanten = ['derbund', 'tagesanzeiger', 'bazonline', 'zsz', 'landbote']
const showlink = mandanten.some((mandant) => url.includes(mandant))
console.log(showlink)
export const content_kultur: {
  title: string
  author: string
  autorBio: string
  content: ReactNode
  link?: number
}[] = [
  {
    title:
      '«House of the Dragon» oder «Ring of Power»: Welche der beiden teuersten Serien des Jahres ist die bessere?',
    author: 'Philippe Zweifel',
    autorBio: '60983857/philippe-zweifel',
    content: (
      <>
        <p>
          Mit «The Rings of Power» kam im Herbst die teuerste Serie aller Zeiten
          heraus. Fast gleichzeitig startete mit ähnlich hohen Produktionskosten
          «House of the Dragon». Beide Serien sind Prequels, von «Lord of the
          Rings» respektive «Game of Thrones». Es ist folglich nicht nur eine
          Debatte unter Fantasy-Nerds, sondern ein grosses Duell innerhalb der
          Popkultur, vergleichbar mit der ewigen Frage, ob nun «Star Wars» oder
          «Star Trek» die bessere Science-Fiction ist.
        </p>
        <Quote>
          Die Kategorien von Gut und Böse überlässt die Serie Tolkiens
          Mittelerde mit seinen hässlichen Orks und edlen Elben.
        </Quote>
        <p>
          Machen wir es hier also kurz: «House of the Dragon» ist besser. Sieht
          zwar mieser aus (dass «Rings of Power» eine Milliarde gekostet hat,
          sieht man der Serie und ihren Spezialeffekten an), aber «House of the
          Dragon» ist weniger formelhaft und im besten Sinn anspruchsvoller.
          Natürlich, da fliegen und feuerspucken ständig irgendwelche Drachen in
          der Gegend herum, es soll ja vor allem Spass machen.
        </p>
        <p>
          Aber letztlich gehts bei «House of the Dragon» um politische Intrigen.
          Die Kategorien von Gut und Böse überlässt die Serie dabei Tolkiens
          Mittelerde mit seinen hässlichen Orks und edlen Elben. Und beschäftigt
          sich stattdessen mit der Frage, welche Mittel im Streben um Macht
          erlaubt sind – was zur gegenwärtigen Erkenntnis führt, dass Herrschaft
          ohne moralische Kompromisse nicht zu haben ist.
        </p>
      </>
    ),
    link: 224308948659,
  },
  {
    title: 'Brauchen Schweizer Festivals eine Frauenquote?',
    author: 'Martin Fischer',
    autorBio: '69287784/martin-fischer',
    content: (
      <>
        <p>
          Keine einzige Musikerin war im Sommer fürs Moon & Stars Festival in
          Locarno gebucht. Als «neue Weltmeister in der Freakshow der
          Diskriminerung», bezeichnete Sophie Hunger nach Veröffentlichung des
          Programms die Veranstalter. Und wieder diskutierte die Schweiz: Wie
          kann das passieren, im Jahr 2022?
        </p>
        <p>
          Der Festivalchef erklärte sich: Es sei schwierig, geeignete weibliche
          Acts zu finden, insbesondere an zugkräftigen Namen fehle es. Es ist
          das Argument, das bei sämtlichen Veranstaltungen mit Männerüberschuss
          bemüht wird. Auch beim Open Air Frauenfeld hiess es dieses Jahr: «Mehr
          war nicht möglich.»
        </p>
        <p>
          Tatsächlich ist die Untervertretung von Frauen ein Branchenproblem,
          das über die Festivalbühnen hinausgeht. Eine erhöhte Sichtbarkeit von
          Musikerinnen ist in allen Bereichen nötig, nicht nur auf den Bühnen,
          sondern auch in den Studios, bei den Managements, auf den
          Streamingplattformen, im Radio. Diese Komponenten greifen alle
          ineinander. Das heisst aber auch: Die Festivals sollen ihren Teil dazu
          beitragen, indem sie weibliche Acts buchen und in grossen Buchstaben
          auf ihre Plakate schreiben. Dass ein hoher Frauenanteil möglich ist,
          nicht nur bei nischigen Indie-Festivals, zeigte etwa das
          Gurtenfestival: Dort standen dieses Jahr 50 Prozent weibliche Acts auf
          dem Programm.
        </p>
        <Quote>Ja, es müsste verbindliche Quoten geben.</Quote>
        <p>
          Das Thema kommt Sommer für Sommer zur Sprache, es muss also etwas
          geschehen. Es gibt inzwischen internationale Initiativen, wie die
          Keychange Initiative, mittels derer sich Veranstaltende zu einer
          Gender-Balance verpflichten. Hier hinkt die Schweiz hinterher, nur
          fünf Festivals sind dabei, in England, Island, Italien oder Estland
          sind es deutlich mehr. Die Berner Musikerin Steff la Cheffe sagte
          gegenüber SRF schon 2018: «Als Initialzündung zur Veränderung einer
          festgefahrenen Situation wäre eine Quote vielleicht gar nicht so
          schlecht.»
        </p>
        <p>
          Ja, es müsste verbindliche Quoten geben. Internationale Tourpläne,
          Releases und Kosten haben zwar ihren Einfluss, jedes Jahr wird es
          nicht möglich sein, eine 50/50-Quote zu erreichen. Aber sie sollte der
          Anspruch sein. Oder wie Michèle Müller vom Paléo Festival, dem
          grössten Open Air der Schweiz, sagt: «Ein diverses Programm ist nicht
          mehr verhandelbar, es ist Pflicht.»
        </p>
        <p>
          Davon profitiert letztlich das Publikum: Es kriegt ein spannenderes
          Programm.
        </p>
      </>
    ),
    link: 460852484188,
  },
  {
    title: 'Waren die Neunziger das beste Jahrzehnt?',
    author: 'Philippe Zweifel',
    autorBio: '60983857/philippe-zweifel',
    content: (
      <>
        <p>
          «Wenn ich Urlaub machen könnte in der Vergangenheit, dann würde ich
          ins Jahr 1994 reisen», schrieb im Frühjahr der Popkritiker Chuck
          Klosterman in seinem Buch «The Nineties». Und löste damit eine Debatte
          aus, ob die 90er-Jahre die beste Dekade der letzten hundert Jahre
          waren. Eingebettet zwischen Mauerfall 1989 und dem Anschlag aufs World
          Trade Center 2001, war das Jahrzehnt, zumindest aus westlicher Sicht,
          tatsächlich eine Zeit, die von wenig Krieg und viel Optimismus geprägt
          war.
        </p>
        <p>
          Der Soundtrack dazu lieferte Techno (die letzte originäre Musik- und
          Jugendkultur und eine, die keine Forderungen stellte, bloss eine gute
          Zeit haben wollte), es wurde an Raves und in Clubs gefeiert, mit einer
          neuen Droge namens Ecstasy – auch sie versprach unkomplizierte
          Glücksgefühle. In der Schweiz fiel das Wirtepatent, die Städte wurden
          mediterranisiert, das Leben verlagerte sich von drinnen nach draussen.
          Bedeuteten die 60er-Jahre Kampf um gesellschaftliche Freiheiten, die
          70er kulturelle und wirtschaftliche Unsicherheiten, die 80er Geld und
          Gier – dann waren die 90er eine Pause von all dem.
        </p>
        <Quote>
          Die Mischung aus Nihilismus und Hedonismus garantierte ein Minimum an
          Gejammer.
        </Quote>
        <p>
          Es war ein unbekümmertes Jahrzehnt, zumal für alle, die damals jung
          waren, also die sogenannte Generation X. Ironischerweise war sie es,
          die das Internet erfand – das Vernetzung und irgendwann auch digitale
          Überforderung in die Nullerjahre brachte. In den 2010er-Jahren kam die
          Sorge um das Klima dazu. Die Jetzt-Zeit ist geprägt von Dauerempörung
          über Diskriminierungen und Empörung über diese Empörung.
        </p>
        <p>
          Kein Wunder, bezeichnet Klosterman den 90er-Zeitgeist und die
          Generation X auch als «am wenigsten nervend»: Die Mischung aus
          Nihilismus und Hedonismus garantierte ein Minimum an Gejammer. Oder um
          es mit dem Motto der ersten Street Parade 1992 zu sagen: «Liebe,
          Friede, Freiheit, Grosszügigkeit und Toleranz.» Viel besser gehts
          tatsächlich nicht.
        </p>
      </>
    ),
    link: 758539711790,
  },
  {
    title: 'Soll St. Gallen seine Mumie zurückgeben?',
    author: 'Andreas Tobler',
    autorBio: '29060640/andreas-tobler',
    content: (
      <>
        <p>
          Kolonialismus und Raubkunst: Die Schweiz wähnte sich lange abseits von
          solchen Problemfeldern. Bis im Zuge der Debatten um die Restitution
          von Kulturgütern, die bisher vor allem in Deutschland und Frankreich
          geführt werden, auch hierzulande allmählich ein Bewusstsein entstand,
          dass vielleicht nicht alles, was in Schweizer Museen ist, dort bleiben
          sollte. In jüngster Zeit weitete sich das Feld allmählich aus auf
          Kunst aus Afrika – und auf sterbliche Überreste, die in hiesigen
          Museen zu sehen sind.
        </p>
        <p>
          Was Letzteres betrifft, ist die St. Galler Schepenese der
          spektakulärste Fall: die Mumie einer ägyptischen Frau aus dem 7.
          Jahrhundert vor Christus. 1820 kam sie in die Schweiz, seit 1836
          gehört sie zum «offiziellen Inventar» der St. Galler Stiftsbibliothek.
          Heute wird sie von Wikipedia zur «Hauptattraktion» der barocken
          Prunkbibliothek gezählt.
        </p>
        <p>
          Der Schweizer Theaterregisseur Milo Rau klagte dies an, als er im
          November den St. Galler Kulturpreis erhielt: Es sei eine «totale
          Absurdität», dass die Mumie sich in St. Gallen befinde und dort
          ausgewickelt dem Publikum gezeigt werde. Rau spendete das
          Kulturpreisgeld von 30’000 Franken für eine Rückführung der Mumie nach
          Ägypten und organisierte eine symbolische Aktion, bei der eine
          Schepenese-Puppe in einem Totenschiff durch St. Gallen geführt wurde.
        </p>
        <Quote>
          Es geht nicht an, dass in der Schweiz mit einem «War schon immer so»
          allzu rasch Diskussionen beendet werden.
        </Quote>
        <p>
          Zunächst stiess dies auf Empörung: Raus Vorstoss sei «billiger
          Populismus», eine «verwerfliche Aktion», hiess es in St. Gallen. Bis
          1983 sei es legal gewesen, Mumien aus Ägypten zu exportieren, wandten
          einige Fachleute ein. Im Herkunftsland gebe es kein Interesse an einer
          weiteren Mumie, hiess es in einer Umfrage der CH-Media. Es gab aber
          auch Gegenstimmen: Menschliche Überreste sollten «wenn möglich» nach
          Ägypten zurückgeführt werden, erklärte Tarek Tawfik,
          Archäologieprofessor an der Universität Kairo und ehemaliger Direktor
          des Grand Egyptian Museum.
        </p>
        <p>
          Seither ist viel passiert: Der Katholische Konfessionsteil als
          Eigentümer der St. Galler Stiftsbibliothek will eine Überführung der
          Mumie nach Ägypten «seriös» prüfen, und zwar «zeitnah», indem man auf
          eine «würdevolle Diskussion einbiegen» wolle.
        </p>
        <p>
          Das ist richtig: Es geht nicht an, dass in der Schweiz mit einem «War
          schon immer so» oder «Bei uns ist eh alles besser» allzu rasch
          Diskussionen beendet werden. Die Schweizer Museen müssen Rechenschaft
          über die Herkunft ihrer Ausstellungsstücke ablegen – und diese an die
          Herkunftsländer zurückgeben.
        </p>
      </>
    ),
    link: showlink ? 749736175014 : undefined,
  },
]
